import {useMutation, useQueryClient, UseMutationResult} from '@tanstack/react-query';
import {blocksApi} from '../../block';
import {useNotifications} from '../../../shared';

type StoryActionsState = {
  publishStoryMutation: UseMutationResult<unknown, Error, string>;
  unpublishStoryMutation: UseMutationResult<unknown, Error, string>;
  deleteStoryMutation: UseMutationResult<unknown, Error, string>;
};

export const useStoryActions = (): StoryActionsState => {
  const queryClient = useQueryClient();
  const {createNotification} = useNotifications();

  const publishStoryMutation = useMutation({
    mutationFn: blocksApi.publishStory,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['story'], refetchType: 'all'});
      queryClient.invalidateQueries({queryKey: ['block-stories', 'infinite'], refetchType: 'all'});
      queryClient.invalidateQueries({queryKey: ['fundraiser-stories', 'infinite'], refetchType: 'all'});
      createNotification({
        title: 'История успешно опубликована',
        name: 'publishStory',
        theme: 'success',
      });
    },
  });

  const unpublishStoryMutation = useMutation({
    mutationFn: blocksApi.unpublishStory,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['story'], refetchType: 'all'});
      queryClient.invalidateQueries({queryKey: ['block-stories', 'infinite'], refetchType: 'all'});
      queryClient.invalidateQueries({queryKey: ['fundraiser-stories', 'infinite'], refetchType: 'all'});
      createNotification({
        title: 'История снята с публикации',
        name: 'unpublishStory',
        theme: 'success',
      });
    },
  });

  const deleteStoryMutation = useMutation({
    mutationFn: blocksApi.deleteStoryById,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['story'], refetchType: 'all'});
      queryClient.invalidateQueries({queryKey: ['block-stories', 'infinite'], refetchType: 'all'});
      queryClient.invalidateQueries({queryKey: ['fundraiser-stories', 'infinite'], refetchType: 'all'});
      createNotification({
        title: 'История успешно удалена',
        name: 'deleteStoryById',
        theme: 'success',
      });
    },
  });

  return {
    publishStoryMutation,
    unpublishStoryMutation,
    deleteStoryMutation,
  };
};
